import React from 'react';

import { Navegador, NavBar } from '@components';
import { rotas, menu } from '@settings';
import api from '@api';
import navigate from '@utils/navigate';

export default function App() {
	const [state, setState] = React.useState(null);

	const logado = React.useMemo(() => !!state?.accessTokenAtivo, [state]);
	const canRefresh = React.useMemo(() => !!state?.refreshTokenAtivo, [state]);

	React.useEffect(() => {
		setState({
			accessTokenAtivo: api.auth.accessTokenAtivo(),
			refreshTokenAtivo: api.auth.refreshTokenAtivo(),
		});

		const unsubscribe = api.auth.addListener(({ accessTokenAtivo, refreshTokenAtivo }) => {
			setState({ accessTokenAtivo, refreshTokenAtivo });
		});

		return () => {
			unsubscribe();
		};
	}, []);

	if (!state) return null;

	if (!logado && canRefresh) {
		api.auth.refresh();
	} else if (!logado && !canRefresh && window.location.hash !== '#login') {
		navigate('#login');
	}

	return (
		<div className={logado ? 'container bg-white p-0' : 'container'} style={{ minHeight: '100vh', minWidth: '90%' }}>
			{logado ? <NavBar menu={menu} /> : null}
			<Navegador rotas={rotas} api={api} />
		</div>
	);
}
